import React from "react";
import ReactDOM from "react-dom";
import { ClockIcon } from "assets/icons";
import Button from "components/button";
import Modalstructure from "components/modal/components/structure";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import UseContext from "hooks/useContext";
import {
    getMonthName,
    parsePayMonth,
    translateEndOfMission,
    translateWithMonth,
} from "pages/content/justificatifs/endOfMissionDocuments/endOfMissionTexts";

// Rendered with the shared modal layout but local state: the global modal registry
// (useModal) cannot carry the document's payMonth.
const PendingDocumentModal = ({ document, onClose }) => {
    const { language } = UseContext();
    const portalTarget = typeof window !== "undefined" ? window.document.getElementById("root-portal") : null;
    if (!document || !portalTarget) return null;

    const payMonth = parsePayMonth(document.payMonth);
    const nextMonth = parsePayMonth(document.payMonth, 1);
    const payMonthName = payMonth ? getMonthName(language, payMonth.monthIndex) : "";
    const nextMonthName = nextMonth ? getMonthName(language, nextMonth.monthIndex) : "";

    return ReactDOM.createPortal(
        <Modalstructure isShowing={true}>
            <Modalheader hide={onClose} hideShow={true}>
                <span className="flex flex-col gap-3">
                    <ClockIcon wh={28} color={"#111827"}/>
                    {translateEndOfMission(
                        language,
                        "pending_modal_title",
                        "Votre attestation France Travail arrive début {month}",
                        { month: nextMonthName }
                    )}
                </span>
            </Modalheader>
            <ModalBody>
                <p className="ft-b text-gray-500">
                    {translateWithMonth(
                        language,
                        "pending_modal_text",
                        "Elle est établie avec votre fiche de paie de {month}.",
                        "Elle est établie avec votre fiche de paie d’{month}.",
                        payMonthName
                    )}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button size={"FULL"} color={"PRIMARY"} onClick={onClose}>
                    {translateEndOfMission(language, "pending_modal_close", "J’ai compris")}
                </Button>
            </ModalFooter>
        </Modalstructure>,
        portalTarget
    );
};

export default PendingDocumentModal;
